import { ActiveBreadcrumb, SwitchContainer, ToggleButton, BreadcrumbContainer, ControlBar, PreviousBreadcrumb, TypeToggle } from './LearningCenterBreadCrumbs.styles';
import React from 'react';
import { Breadcrumbs } from "@material-ui/core";
import PropTypes from 'prop-types';
import { buildTopicHierarchy } from "../../../../templates/resourcesHelperFunctions";

const getAncestorTopics = ( allTopics ) => {
    const ancestorTopics = allTopics?.filter( ( topic ) => topic.ancestors === null );
    return ancestorTopics;
}

const LearningCenterBreadCrumbs = ( props ) => {
    const ancestorTopics = getAncestorTopics( props.allTopics?.nodes );
    return (
        <>
  <ControlBar>
    <BreadcrumbContainer>
      <Breadcrumbs>
        {props.breadcrumbs.map( ( crumb, i ) => (
            !crumb.active ?
                <PreviousBreadcrumb href={crumb.link} key={i}>{crumb.text}</PreviousBreadcrumb> :
                <ActiveBreadcrumb key={i}>{crumb.text}</ActiveBreadcrumb>
        ) )}
      </Breadcrumbs>
    </BreadcrumbContainer>
  </ControlBar>
  </>
    )
};

LearningCenterBreadCrumbs.propTypes = {
    steps: PropTypes.arrayOf( PropTypes.shape( {
        link: PropTypes.string,
        text: PropTypes.string.isRequired,
        active: PropTypes.string.isRequired
    } ) ),
};

LearningCenterBreadCrumbs.defaultProps = {
    steps: null,
};

export default LearningCenterBreadCrumbs;

